import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { isMobileState } from '../../recoil/selectors';
import { SilhouetteBriefLanderMobile } from './SilhouetteBriefLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { allProductsState } from '../../recoil/atoms';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { useProductAssets } from '../../hooks/useProductAssets';
import { CardTitle } from '../../components/CardTitle';
import { assetPathFn } from '../../util';

export const SilhouetteBriefLander: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const isMobile = useRecoilValue(isMobileState);
  const product = allProducts[ProductHandle.SilhouetteBrief];
  const productAssets = useProductAssets(product);
  const wistiaVideoId = productAssets.videos[0]?.wistiaId;
  const padding = { padding: '56.25% 0 0 0' };

  if (isMobile) {
    return <SilhouetteBriefLanderMobile />;
  }

  return (
    <>
      <CardBody>
        <LanderTopHero
          maxHeroContainerHeight={'1066px'}
          heroImage={'desktop-silhouette-brief-lander-top-hero-1.jpg'}
          title={'Silhouette Brief'}
          subTitle={'Underwear that feels as beautiful as it looks.'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                No dig
                <br /> waistband
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            color={'black'}
            labelColor={'black'}
            inlineStyles={{
              desktop: {
                left: `11%`,
                top: `33%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            color={'black'}
            labelColor={'black'}
            label={
              <>
                3D printed velvet
                <br /> compression
              </>
            }
            titleStyles={{ lineHeight: '22px', textAlign: 'right' }}
            inlineStyles={{
              desktop: {
                right: `86%`,
                top: `42%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            color={'black'}
            labelColor={'black'}
            label={
              <>
                High recovery
                <br /> stretch fabric
              </>
            }
            titleStyles={{ lineHeight: '22px', textAlign: 'right' }}
            inlineStyles={{
              desktop: {
                left: `20%`,
                top: `49%`,
                flexDirection: 'row',
              },
            }}
          />
        </LanderTopHero>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-sbrief-desktop-1.jpg',
              title: '3D printed velvet',
              description: 'Senselast technology adds support and style.',
            },
            {
              imgName: 'feature-sbrief-desktop-3.jpg',
              title: 'Wedgie-proof',
              description: 'Designed to smooth your bottom without riding up.',
            },
            {
              imgName: 'feature-sbrief-desktop-2.jpg',
              title: 'Moves with you',
              description: 'LYCRA®️ MyFit fabric features high recovery stretch.',
            },
          ]}
        />
        <CardTitle text={'The Honeylove Difference'} style={{ fontSize: '26pt', paddingTop: 60 }} />
        <div style={{ backgroundColor: '#dfdfe1', display: 'flex', justifyContent: 'center', margin: `40px 60px`, marginTop: 0 }}>
          <img src={assetPathFn('silhouette-brief-annotate-desktop.jpg')} style={{ width: '100%' }} alt="difference" />
        </div>
        {wistiaVideoId && (
          <div style={{ padding: '50px 60px', paddingTop: 40, boxSizing: 'border-box' }}>
            <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
          </div>
        )}
        <ShopAllColors product={allProducts[ProductHandle.SilhouetteBrief]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SilhouetteBriefLander;
